import classNames from "classnames";
import { Card } from "components/ui/card";
import { Color } from "utils/theme";

export const SettingsSection = ({
  label,
  description,
  content,
  horizontal = true,
}) => {
  return (
    <Card className="p-5">
      <div
        className={classNames("flex sm:justify-between items-start ", {
          "flex-col space-y-3": !horizontal,
          "flex-row space-x-6": horizontal,
        })}
      >
        <div className="sm:mb-0 mb-5">
          <h3 className="font-medium text-base mb-1">{label}</h3>
          <p
            className="text-sm max-w-[500px]"
            style={{ color: Color.Primary[400] }}
          >
            {description}
          </p>
        </div>
        {content}
      </div>
    </Card>
  );
};
